import React, { useMemo } from 'react';
import { useHistory } from 'react-router-dom';

import { useAppContext } from '@prisjakt/ui-app-context';

import { H3Text } from '@prisjakt/ui/text/variants';
import { NavigationSliceView } from 'src/areas/product-collection/components/navigation/navigation-component';

import { Section } from './styles';

import { trackSearchResultStoreClicked } from '../../tracking';

import { TabAnchor } from '../navigation/types';
import { Store, Maybe } from 'src/types';
import { FacetLink } from 'src/areas/product-collection/components/navigation/types';

type Props = {
  active: boolean;
  shops: Maybe<Omit<Store, 'userReviewSummary' | 'countryCode' | 'currency'>>[];
  count: number;
  wideContent: boolean;
  showAll?: boolean;
};

export const ShopResults = (props: Props) => {
  const { shops, count, wideContent, active, showAll } = props;

  const { market, t } = useAppContext();
  const history = useHistory();

  const formattedLinks: FacetLink[] = useMemo(
    () =>
      shops?.map(shop => {
        const imageUrl = shop?.hasLogo
          ? `${market.imageCdnUrl}g/ftg_logos/store_${shop.id}.png`
          : undefined;

        const link: FacetLink = {
          id: shop?.id?.toString() || '',
          value: shop?.name || '',
          selected: false,
          path: shop?.pathName,
          imageUrl,
          indexable: true,
        };
        return link;
      }) ?? [],

    [market.imageCdnUrl, shops]
  );

  return shops?.length ? (
    <Section id={TabAnchor.STORES} $active={active}>
      <H3Text>{`${t('search', 'stores.title')} (${count})`}</H3Text>

      <NavigationSliceView
        links={formattedLinks}
        onClick={(link: FacetLink) => {
          if (link.path) {
            history.push(link.path);
            trackSearchResultStoreClicked(link.id, link.value);
          }
        }}
        {...(wideContent && { itemLimit: 9 })}
        showAll={showAll}
      />
    </Section>
  ) : null;
};
